<template>
  <div class="box">
    <navBar :tabIndex="0"></navBar>
    <div class="freeImg" v-if="ifShowZxNum == 0" @click="ifShowZxNum = 1"></div>
    <div class="zxImgGo" v-else-if="ifShowZxNum == 1">
      <img
        @click.stop="ifShowZxNum = 2"
        class="closeImg"
        src="@/assets/close-g.png"
        alt=""
      />
      <div class="zxTit">手机版</div>
      <div class="zxTitle">扫码即可进入知孝小程序</div>
      <img
        class="zxImg"
        src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/zxUrlIcon.png"
        alt=""
      />
    </div>
    <div class="topImg">
      <el-carousel
        indicator-position="none"
        :height="$px2rem(`${391}px`)"
        arrow="never"
        ref="carousel"
        :initial-index="0"
        :autoplay="true"
        @change="carChange"
      >
        <el-carousel-item v-for="(item, index) in lunboList" :key="index">
          <div style="position: relative">
            <img
              @click="toBuild(item)"
              :src="item.url"
              alt=""
              style="cursor: pointer"
              class="topBg"
            />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="getTapIt">
      <div
        v-for="(item, index) in areaData"
        :key="index"
        class="areaIt"
        @click="toDoFuc(item)"
      >
        <img :src="item.pcPic" class="areaItem" alt="" />
        <div class="cloLine" v-if="index + 1 !== areaData.length"></div>
      </div>
    </div>
    <div class="toDatenum" id="jdMan">
      <div class="doneIt">
        <img class="doneIcon" src="@/assets/jn-icon.png" alt="" srcset="" />
        <div class="doneRight">
          <div class="doneNum">
            {{ hallStatcs.hallCount || 0
            }}<span
              style="margin-left: 3px; color: #8f8f9c; font-weight: 400"
              :style="{
                'font-size': $px2rem(`${14}px`),
              }"
              >个</span
            >
          </div>
          <div class="doneTitle">纪念馆</div>
        </div>
      </div>
      <div class="doneIt">
        <img
          class="doneIcon"
          style="margin-right: 0"
          src="@/assets/qf-icon.png"
          alt=""
          srcset=""
        />
        <div class="doneRight">
          <div class="doneNum">
            {{ hallStatcs.giftCount || 0
            }}<span
              style="margin-left: 3px; color: #8f8f9c; font-weight: 400"
              :style="{
                'font-size': $px2rem(`${14}px`),
              }"
              >次</span
            >
          </div>
          <div class="doneTitle">祈福</div>
        </div>
      </div>
      <div class="doneIt">
        <img class="doneIcon" src="@/assets/user-icon.png" alt="" srcset="" />
        <div class="doneRight">
          <div class="doneNum">
            {{ hallStatcs.userCount || 0
            }}<span
              style="margin-left: 3px; color: #8f8f9c; font-weight: 400"
              :style="{
                'font-size': $px2rem(`${14}px`),
              }"
              >次</span
            >
          </div>
          <div class="doneTitle">用户使用</div>
        </div>
      </div>
    </div>
    <div class="toDayNews">
      <div class="menuBox">
        <div
          class="menuIt"
          @click="toDoFuc(item)"
          v-for="(item, index) in menuList"
          :key="index"
        >
          <img class="menuItem" :src="item.pcPic" alt="" />
          <div class="menuName">{{ item.name }}</div>
        </div>
      </div>
      <div class="title-flex-sb">
        <div class="td-title" style="margin: 0">公众纪念馆</div>
        <div class="title-flex" @click="toPublic">
          <div
            style="color: #8a8a8a"
            :style="{
              'font-size': $px2rem(`${18}px`),
            }"
          >
            更多
          </div>
          <img class="rightIcon" src="@/assets/right-icon.png" alt="" />
        </div>
      </div>
      <div class="bzBox" v-if="outList && outList.length > 0">
        <div class="bzIt">
          <div
            class="bzItem"
            v-for="(item, index) in outList.slice(0, 6)"
            :key="index"
            @click.stop="toWorship(item)"
            :style="{
              'margin-right': (index + 1) % 3 == 0 ? '0' : $px2rem(`${15}px`),
            }"
          >
            <img
              class="bzImg"
              :src="item.picture ? item.picture : item.spiritTabletUrl"
              alt=""
            />
            <div class="bz-sb">
              <div class="bz-name">
                {{ item.name }}
              </div>
              <div class="bz-remark">
                {{ item.introduction || "暂无简介" }}
              </div>
              <div class="bz-boter">
                <div class="bx-flex">
                  <img
                    class="fireIcon"
                    src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/fireIcon.png"
                    alt=""
                  />
                  <div class="bx-text">
                    {{ item.actionStat.totalSpecialCount }}
                  </div>
                </div>
                <div class="bx-flex">
                  <img
                    class="viewIcon"
                    src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/viewIcon.png"
                    alt=""
                  />
                  <div class="bx-text">
                    {{ item.actionStat.totalView }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="td-title" v-if="tdList && tdList.length > 0">今日生祭</div>
      <div class="td-Item" v-if="tdList && tdList.length > 0">
        <div
          v-for="(item, index) in tdList"
          :key="index"
          @click.stop="toWorship(item)"
          class="tdItem"
        >
          <img
            class="manIcon"
            :src="item.picture"
            alt=""
            srcset=""
            v-if="item.picture"
          />
          <div class="manIcon-none" v-else>
            <img
              class="manIconimg"
              :src="item.spiritTabletUrl"
              alt=""
              srcset=""
            />
          </div>
          <div>
            <div class="tdFlex">
              <div class="tdName">
                {{
                  item.name && item.name.length > 5
                    ? item.name.slice(0, 5) + "..."
                    : item.name
                }}
              </div>
              <div v-if="item.label == 1" class="tdTip1">今日诞辰</div>
              <div v-else class="tdTip2">今日忌日</div>
            </div>
            <div class="tdTime">
              {{ item.birthDay || "不详" }}-{{ item.dieDay || "不详" }}
            </div>
            <div class="tdCom">{{ item.latestMessage || "--" }}</div>
          </div>
        </div>
      </div> -->
      <!-- <div class="title-flex-sb" v-if="homeList && homeList.length > 0">
        <div class="td-title" style="margin: 0">我的纪念馆</div>
        <div class="title-flex">
          <div
            style="color: #8a8a8a"
            :style="{
              'font-size': $px2rem(`${18}px`),
            }"
            @click="toMemo(2)"
          >
            更多
          </div>
          <img class="rightIcon" src="@/assets/right-icon.png" alt="" />
        </div>
      </div> -->
      <!-- <div class="dd-It" v-if="homeList && homeList.length > 0">
        <div
          v-for="(item, index) in homeList"
          :key="index"
          class="dd-Item"
          :style="{
            'margin-right': (index + 1) % 6 == 0 ? '0' : $px2rem(`${18}px`),
          }"
          @click.stop="toWorship(item)"
          @mouseover="fnThrottle(item, index)"
          @mouseout="fnThrottle(item, index)"
        >
          <div
            :style="{
              width: $px2rem(`${186}px`),
              height: $px2rem(`${184}px`),
              border: item.picture ? 'none' : '1px solid #EAAC49',
            }"
            style="position: relative; overflow: hidden; border-radius: 10px"
          >
            <div class="dd-img" :class="{ imgFil: item.check == true }">
              <img
                style="object-fit: cover"
                :style="{
                  width: $px2rem(`${186}px`),
                  height: $px2rem(`${184}px`),
                  'border-radius': $px2rem(`${10}px`),
                  'object-fit': item.picture ? 'cover' : 'none',
                }"
                :src="item.picture ? item.picture : item.spiritTabletUrl"
                alt=""
              />
            </div>
            <div class="dd-renqi" v-show="!item.check">
              <img
                v-if="item.isHot == 1"
                class="fire-img"
                src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/fire.png"
                alt=""
              />
            </div>
            <div v-show="item.check == true" class="cavorIs">
              <div
                class="toWorship"
                v-show="item.check == true"
                @click.stop="toWorship(item)"
              >
                去祭拜
              </div>
            </div>
          </div>
          <div class="dd-bottom">
            <div class="dd-name">
              {{
                item.name && item.name.length > 5
                  ? item.name.slice(0, 5) + "..."
                  : item.name
              }}
            </div>
            <div class="dd-flex-b">
              <div class="dd-g-xh">香火</div>
              <div class="dd-g-title" style="color: #dca10a">
                {{ item.actionStat.totalSpecialCount }}
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="title-flex-sb" v-if="bzList && bzList.length > 0">
        <div class="td-title" id="jdMan" style="margin: 0">始祖</div>
        <div class="title-flex">
          <div
            style="color: #8a8a8a"
            :style="{
              'font-size': $px2rem(`${18}px`),
            }"
            @click="tofounder"
          >
            更多
          </div>
          <img class="rightIcon" src="@/assets/right-icon.png" alt="" />
        </div>
      </div> -->
      <!-- <div class="bzBox" v-if="bzList && bzList.length > 0">
        <div class="bzIt">
          <div
            class="bzItem"
            v-for="(item, index) in bzList.slice(0, 3)"
            :key="index"
            @click.stop="toWorship(item)"
          >
            <img
              class="bzImg"
              :src="item.picture ? item.picture : item.spiritTabletUrl"
              alt=""
            />
            <div class="bz-sb">
              <div class="bz-name">{{ item.name }}</div>
              <div class="bz-time" v-if="item.birthDay || item.dieDay">
                {{ setStrgos(item.birthDay) || "???" }}-{{
                  setStrgos(item.dieDay) || "???"
                }}
              </div>
              <div class="bz-remark">
                {{ item.introduction || "暂无简介" }}
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="title-flex-sb" v-if="deadList && deadList.length > 0">
        <div class="td-title" id="jdMan" style="margin: 0">名人纪念馆</div>
        <div class="title-flex">
          <div
            style="color: #8a8a8a"
            :style="{
              'font-size': $px2rem(`${18}px`),
            }"
            @click="toMemo(1)"
          >
            更多
          </div>
          <img class="rightIcon" src="@/assets/right-icon.png" alt="" />
        </div>
      </div> -->
      <!-- <div class="new-tab">
        <div class="new-tabLeft">
          <div
            class="newTabIt"
            v-for="(item, index) in tabList.slice(0, 8)"
            :key="index"
            @click.stop="changeTab(item, index)"
            :style="{
              color: tabIndex == index ? '#010101' : '#8A8A8A',
              'font-weight': tabIndex == index ? '600' : '400',
            }"
          >
            <div style="white-space: pre">{{ item.name }}</div>
            <div class="ntline" v-if="tabIndex == index"></div>
          </div>
        </div>
        <div class="new-tabRight" @click="toMemo(1)">
          <div class="nt-more">更多</div>
          <img class="nt-moreIcon" src="@/assets/right-icon.png" alt="" />
        </div>
      </div> -->
      <!-- <div class="dd-It" v-if="deadList && deadList.length > 0">
        <div
          v-for="(item, index) in deadList"
          :key="index"
          class="dd-Item"
          :style="{
            'margin-right': (index + 1) % 6 == 0 ? '0' : $px2rem(`${18}px`),
          }"
          @click.stop="toWorship(item)"
        >
          <div
            :style="{
              width: $px2rem(`${186}px`),
              height: $px2rem(`${184}px`),
              border: item.picture ? 'none' : '1px solid #EAAC49',
              'border-radius': $px2rem(`${10}px`),
            }"
            style="position: relative; overflow: hidden"
            @mouseover="fnThrottle(item, index)"
            @mouseout="fnThrottle(item, index)"
          >
            <div class="dd-img" :class="{ imgFil: item.check == true }">
              <img
                id="ddImg"
                :style="{
                  width: $px2rem(`${186}px`),
                  height: $px2rem(`${184}px`),
                  'border-radius': $px2rem(`${10}px`),
                  'object-fit': item.picture ? 'cover' : 'none',
                }"
                :src="item.picture ? item.picture : item.spiritTabletUrl"
                alt=""
              />
            </div>
            <div class="dd-renqi" v-show="!item.check">
              <img
                v-if="item.isHot == 1"
                class="fire-img"
                src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/fire.png"
                alt=""
              />
            </div>
            <div
              v-show="item.check == true"
              class="cavorIs"
              id="cavorIs"
              @click.stop="toWorship(item)"
            >
              <div class="toWorship" v-show="item.check == true">去祭拜</div>
            </div>
          </div>
          <div class="dd-bottom">
            <div class="dd-name">
              {{
                item.name && item.name.length > 5
                  ? item.name.slice(0, 5) + "..."
                  : item.name
              }}
            </div>
            <div class="dd-flex-b">
              <div class="dd-g-xh">香火</div>
              <div class="dd-g-title">
                {{ item.actionStat.totalSpecialCount }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dd-Itnone" v-else></div> -->
    </div>
    <div class="wallBox">
      <div class="boTcons">
        <div class="boTtitle">思念祈福墙</div>
        <div class="wallIt">
          <div
            v-for="(item, index) in wallList.slice(0, 4)"
            :key="index"
            @click.stop="toWorship(item)"
            class="wallItem"
            :style="{
              'margin-right': (index + 1) % 4 == 0 ? '0' : $px2rem(`${10}px`),
            }"
          >
            <img
              class="wallImg"
              :src="item.picture"
              alt=""
              srcset=""
              v-if="item.picture"
            />
            <div class="wallImg-none" v-else>
              <img
                class="wallImgimg"
                :src="item.spiritTabletUrl"
                alt=""
                srcset=""
              />
            </div>
            <div
              class="wall-comment"
              :style="{
                'text-indent':
                  item.latestMessage && item.latestMessage.length > 20
                    ? $px2rem(`${26}px`)
                    : '0',
              }"
            >
              {{ item.latestMessage }}
            </div>
            <div
              class="wall-flex wall-Its"
              style="justify-content: space-between"
              :style="{
                'margin-left': $px2rem(`${42}px`),
                'margin-right': $px2rem(`${42}px`),
              }"
            >
              <div class="wall-flex">
                <img
                  :src="
                    item.latestMessageSendUserPicture
                      ? item.latestMessageSendUserPicture
                      : 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo/user-default.png'
                  "
                  class="wall-icon"
                  alt=""
                  srcset=""
                />
                <div class="last-name">
                  {{ item.latestMessageSendName || "--" }}
                </div>
              </div>
              <div class="last-time">
                {{ item.latestMessageSendTime }}
              </div>
            </div>
          </div>
        </div>
        <div class="boTtitle">
          文化广场
          <div class="newsMore" @click.stop="goNews">
            更多
            <img class="rightIcon" src="@/assets/right-icon-y.png" alt="" />
          </div>
        </div>
        <div class="newsIt">
          <div
            v-for="(item, index) in newsList.slice(0, 4)"
            :key="index"
            class="newsItem"
            @click="goMain(item)"
          >
            <img class="newsImg" :src="item.coverUrl" alt="" />
            <div class="newsTitle">{{ item.title }}</div>
            <div
              class="newsCont"
              v-html="item.content.replace(/\s+|(<br>)+/g, '')"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <tabBar></tabBar>
  </div>
</template>

<script>
import {
  getNewsDate,
  getHallStatistic,
  getHallToday,
  getHallWall,
  getHallHuman,
  checkLogin,
  getTapType,
  bannerPicAppQuery,
  getActiveArea,
  navTabAppList,
} from "@/api/request";

export default {
  components: {},
  data() {
    return {
      imgList: [],
      colList: [],
      goIndex: 0,
      tdList: [],
      deadList: [],
      allFamList: [],
      homeList: [],
      wallList: [],
      hallStatcs: {},
      mouseIndex: 0,
      requestStatus: false,
      bzList: [],
      newsList: [],
      ifShowZxNum: 0,
      tabIndex: 0,
      tabList: [],
      outList: [],
      lunboList: [],
      areaData: [
        {
          pcPic:
            "https://oss.lgyin.com/file/48430d57-15ea-4b3e-b969-f5a0eea3e3a0.68a87097-a7b2-4bd2-8dd4-47b71ffcb43b",
          pcLinkType: "switchTab",
          pcLink: "/venue",
        },
      ],
      areaIndex: 0,
      menuList: [],
    };
  },
  created() {
    //this.getLogo();
    this.getOutList();
    //this.getHallHumanMy();
    this.getHallWalls();
    //this.getBzList();
    //this.getHallHumans();
    this.getHallStatistics();
    //this.getHallTodays();
    this.checkLogins();
    this.getNews();
    this.getTaps();
    this.getBannerPicAppQuery();
    this.postGetActiveArea();
    this.postNavTabAppList();
  },
  mounted() {},
  onReady() {
    this.$watch(
      () => {
        return this.$refs.carousel._data.activeIndex;
      },
      (val) => {
        //this.$refs.carousel.setActiveItem(val);
        if (this.imgList[val].check == true) {
          this.imgList[val].check = false;
        } else {
          this.imgList[val].check = true;
        }
        this.imgList.map((a, j) => {
          if (val != j) {
            this.imgList[j].check = false;
          } else {
            this.imgList[j].check = true;
          }
        });
        this.$forceUpdate();
      }
    );
  },
  watch: {
    // 监听路由对象中的参数变化
    "$route.query": {
      immediate: true, // 初始化时立即触发
      handler(newQuery, oldQuery) {
        // 检查特定参数是否存在
        if ("fxInviteCode" in newQuery) {
          // 执行相应操作
          console.log("URL有fxInviteCode参数：", newQuery.fxInviteCode);
          localStorage.setItem("inviteCode", newQuery.fxInviteCode);
        } else {
          // 参数不存在的处理
          console.log("URL中不存在fxInviteCode参数");
        }
      },
    },
  },
  methods: {
    //获取首页轮播图
    getBannerPicAppQuery() {
      bannerPicAppQuery(4).then((res) => {
        if (res.code == 200) {
          this.lunboList = res.data.data || [];
        }
      });
    },
    postGetActiveArea() {
      getActiveArea().then((res) => {
        if (res.code == 200) {
          this.areaData = [...this.areaData, ...res.data.data.tabs];
        }
      });
    },
    postNavTabAppList() {
      navTabAppList().then((res) => {
        if (res.code == 200) {
          res.data.data.map((e) => {
            this.menuList.push(e);
          });
        }
      });
    },
    toDoFuc(e) {
      console.log(e);
      if (e.pcLinkType !== "applets") {
        this.$router.push({ path: e.pcLink });
      }
    },
    setStrgos(str) {
      if (str) {
        let index = str.indexOf("-");
        let result = str.substring(0, index);
        return result;
      } else {
        return "";
      }
    },
    getTaps() {
      let data = {
        pageNum: 1,
        pageSize: 8,
      };
      getTapType(data).then((res) => {
        this.tabList = [{ name: "推荐" }, ...res.data.result.records];
      });
    },
    changeTab(e, i) {
      this.tabIndex = i;
      this.tabTypeId = null;
      if (i == 0) {
        this.getHallHumans();
      } else {
        this.tabTypeId = e.id;
        this.getHallHumans();
      }
    },
    getViewportSize() {
      var pageWidth = window.innerWidth,
        pageHeight = window.innerHeight;
      // 判断浏览器是否支持innerWidth
      if (typeof pageWidth !== "number") {
        // 文档渲染模式是标准模式
        if (document.compatMode == "CSS1Compat") {
          pageWidth = document.documentElement.clientWidth;
          pageHeight = document.documentElement.clientHeight;
        } else {
          // 文档渲染模式是混杂模式或怪异模式
          pageWidth = document.body.clientWidth;
          pageHeight = document.body.clientHeight;
        }
      }
      return {
        pageWidth,
        pageHeight,
      };
    },
    goNews() {
      this.$router.push({
        path: "/news",
      });
    },
    goMain(e) {
      this.$router.push({
        path: "/newsMain",
        query: {
          id: e.id,
        },
      });
    },
    getNews() {
      let data = {
        pageNo: 1,
        pageSize: 4,
        type: 1,
        secondType: 100,
      };
      getNewsDate(data).then((res) => {
        this.newsList = res.data.result.records;
      });
    },
    getBzList() {
      let data = {
        type: 3,
        pageSize: 3,
      };
      getHallHuman(data).then((res) => {
        this.bzList = res.data.result.records;
      });
    },
    getOutList() {
      let data = {
        type: 4,
        pageSize: 6,
      };
      getHallHuman(data).then((res) => {
        let arr = res.data.result.records;
        this.outList.push(...arr);
      });
    },
    toBuild(e) {
      console.log(e);
      if (localStorage.getItem("token")) {
        this.$router.push({ path: e.link });
      } else {
        this.$router.push("login");
      }

      // this.$router.push("/venue");
      // localStorage.setItem("tabIndex", 2);
    },
    checkLogins() {
      checkLogin().then((res) => {
        if (res.data.result == false) {
          this.$store.commit("REMOVE_TOKEN");
        } else {
        }
      });
    },
    getHallStatistics() {
      getHallStatistic().then((res) => {
        this.hallStatcs = res.data.result;
      });
    },
    getHallTodays() {
      getHallToday().then((res) => {
        this.tdList = res.data.result;
      });
    },
    getHallWalls() {
      let data = {
        pageNo: 1,
        pageSize: 8,
      };
      getHallWall(data).then((res) => {
        this.wallList = res.data.result.records;
      });
    },
    getHallHumans() {
      let data = {
        type: 1,
        pageSize: 6,
        typeId: this.tabTypeId,
      };
      getHallHuman(data).then((res) => {
        this.deadList = res.data.result.records;
        this.deadList.map((e) => {
          e.check = false;
        });
        this.allFamList = res.data.result.records;
        this.allFamList.map((e) => {
          e.check = false;
        });
      });
    },
    getHallHumanMy() {
      let data = {
        type: 2,
        pageSize: 6,
      };
      getHallHuman(data).then((res) => {
        res.data.result.records.map((e) => {
          e.check = false;
        });
        this.homeList = res.data.result.records;
      });
    },
    getFormatDate() {
      var date = new Date();
      var seperator = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var nowDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (nowDate >= 0 && nowDate <= 9) {
        nowDate = "0" + nowDate;
      }
      var newDate = year + seperator + month + seperator + nowDate;
      return newDate;
    },
    toPublic() {
      this.$router.push({ path: "/public" });
    },
    tofounder() {
      this.$router.push({ path: "/founder" });
    },
    toMemo(e) {
      if (e == 1) {
        this.$router.push({ path: "/memo", query: { id: e } });
      } else {
        this.$router.push({ path: "/homeMemo", query: { id: e } });
      }
    },

    toWorship(e) {
      if (e.isStele == 1) {
        this.$router.push({ path: "/stele", query: { id: e.id } });
      } else {
        this.$router.push({ path: "/worship", query: { id: e.id } });
      }
    },
    carChange(e) {
      this.goIndex = e;
    },
    getLogo() {
      let data = {
        pageNo: 1,
        pageSize: 10,
        type: 3,
        secondType: 8,
      };
      getNewsDate(data).then((res) => {
        this.imgList = res.data.result.records;
        this.imgList.map((e) => {
          e.check = false;
        });
        this.imgList[0].check = true;
      });
    },
    changeCar(i) {
      this.$refs.carousel.setActiveItem(i);
      if (this.imgList[i].check == true) {
        this.imgList[i].check = false;
      } else {
        this.imgList[i].check = true;
      }
      this.imgList.map((a, j) => {
        if (i != j) {
          this.imgList[j].check = false;
        } else {
          this.imgList[j].check = true;
        }
      });
      this.$forceUpdate();
    },
    change(i) {
      if (this.colList[i].check == true) {
        this.colList[i].check = false;
      } else {
        this.colList[i].check = true;
      }
      this.colList.map((a, j) => {
        if (i != j) {
          this.colList[j].check = false;
        } else {
          this.colList[j].check = true;
        }
      });
      this.$forceUpdate();
    },

    mouseover0(e, i) {
      if (e.check == false) {
        e.check = true;
        this.mouseIndex = i;
        this.deadList[i].check = true;
        this.deadList.map((a, j) => {
          if (i != j) {
            this.deadList[j].check = false;
          }
        });
        this.$forceUpdate();
      }
    },
    mouseout0(e, i) {
      if (e.check == true) {
        e.check = false;
        this.mouseIndex = i;
        this.deadList[i].check = false;
        this.deadList.map((a, j) => {
          if (i != j) {
            this.deadList[j].check = false;
          }
        });
        this.$forceUpdate();
      }
    },
    mouseover1(e, i) {
      if (e.check == false) {
        e.check = true;
        this.mouseIndex = i;
        //this.homeList[i].check = true;
        this.$forceUpdate();
      }
    },
    mouseout1(e, i) {
      if (e.check == true) {
        e.check = false;
        this.mouseIndex = i;
        // this.homeList[i].check = false;
        this.$forceUpdate();
      }
    },
    mouseFuc(e, i, timer = 100) {
      //节流防抖
      if (this.requestStatus) {
        return false;
      }
      this.fnThrottle(e, i);
      this.requestStatus = true;
      setTimeout(() => {
        this.requestStatus = false;
      }, timer);
    },
    fnThrottle(e, i) {
      e.check = !e.check;
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss"  scoped>
@import "./main.scss";
.box {
  background: #f5f9f3;
}
.topImg {
  height: 391px;
  position: relative;
  // padding-top: 60px;
  z-index: 990;
}
.getTapIt {
  width: 100%;
  height: 117px;
  background: url("https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/main-top-itbg.png")
    no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .areaIt {
    display: flex;
    align-items: center;
  }
  .areaItem {
    width: 330px;
    height: 118px;
    cursor: pointer;
  }
  .cloLine {
    background: #dcb98a;
    width: 1px;
    height: 65px;
    margin: 0 50px;
  }
}
.topBox {
  width: 760px;
  height: 269px;
  position: absolute;
  top: 44px;
  left: 312px;
  display: flex;
  justify-content: space-between;
  z-index: 999;
}
.qm-left {
  width: 269px;
  height: 269px;
  position: relative;
}
.qm-icon {
  width: 269px;
  height: 269px;
  position: absolute;
  left: 0;
}
.qm-bd {
  width: 27px;
  height: 236px;
  position: absolute;
  right: 20px;
}
.qm-right {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.qm-title {
  width: 472px;
  height: 50px;
  margin-top: 24px;
}
.qm-tips {
  width: 218px;
  height: 19px;
  margin-top: 22px;
}
.buildTory {
  width: 146px;
  line-height: 51px;
  text-align: center;
  border: 4px solid #039e85;
  font-weight: 600;
  font-size: 16px;
  color: #236f63;
  margin-top: 42px;
  box-sizing: border-box;
  cursor: pointer;
  white-space: pre;
}
.flexbox {
  display: flex;
  justify-content: center;
}

img {
  width: 100%;
  // image-rendering: -moz-crisp-edges;
  // image-rendering: -o-crisp-edges;
  // image-rendering: -webkit-optimize-contrast;
  // image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}
.toDayNews {
  padding: 32px 0 0px 0;
  width: 1200px;
  margin: 0 auto;
  .menuBox {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 50px;
    .menuIt {
      width: 300px;
      height: 122px;
      background: url("https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/menuBg.png")
        no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      padding: 16px 46px 26px 46px;
      box-sizing: border-box;
      cursor: pointer;
      .menuItem {
        width: 68px;
        height: 68px;
        flex: none;
        margin-right: 16px;
      }
      .menuName {
        color: #592f10;
        font-size: 23px;
      }
    }
  }
}
.td-Item {
  display: flex;
  width: 1200px;
  justify-content: space-between;
  margin-bottom: 70px;
}
.tdItem {
  border-radius: 10px;
  background: #fff;
  width: 590px;
  height: 160px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  cursor: pointer;
}
.manIcon {
  width: 120px;
  height: 120px;
  margin-right: 28px;
  flex: none;
  border-radius: 10px;
  object-fit: cover;
}
.manIcon-none {
  width: 120px;
  height: 120px;
  margin-right: 28px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #eaac49;
}
.manIconimg {
  width: 70px;
  height: 100px;
  flex: none;
}
.tdFlex {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.tdName {
  margin-right: 10px;
  color: #323232;
  font-weight: 600;
  font-size: 18px;
}
.tdTime {
  color: #323232;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  margin-bottom: 10px;
}
.tdCom {
  color: #8a8a8a;
  font-size: 14px;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}
.tdTip1 {
  width: 66px;
  line-height: 24px;
  background: linear-gradient(180deg, #fed699 -19.51%, #e3b065 100%);
  border-radius: 6px;
  color: #513916;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
}
.tdTip2 {
  width: 66px;
  line-height: 24px;
  background: linear-gradient(180deg, #9e9e9e -19.51%, #4f4e4d 100%);
  border-radius: 6px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
}
.toDatenum {
  width: 1200px;
  height: 106px;
  background: #fff;
  border-radius: 11px;
  box-shadow: 0px 4px 19px 0px #87a29d21;
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 505px;
  z-index: 991;
  padding: 23px 188px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  display: none;
}
.doneIt {
  display: flex;
  align-items: center;
}
.doneIcon {
  width: 60px;
  height: 60px;
  margin-right: 16px;
  flex: none;
}
.doneNum {
  font-size: 20px;
  color: #323232;
  font-weight: 600;
  text-align: left;
}
.doneTitle {
  color: #323232;
  text-align: left;
}
.title-flex-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.title-flex {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.rightIcon {
  width: 9px;
  height: 13px;
  margin-left: 8px;
}
.td-title {
  color: #010101;
  font-size: 20px;
  font-weight: 600;
  text-align: left;
  margin-bottom: 18px;
}
.bzBox {
  margin-bottom: 52px;
  .bzIt {
    width: 1200px;
    display: flex;
    //justify-content: space-between;
    flex-wrap: wrap;
    .bzItem {
      width: 390px;
      height: 188px;
      background: #fff;
      border-radius: 10px;
      display: flex;
      padding: 20px;
      box-sizing: border-box;
      cursor: pointer;
      margin-bottom: 16px;
    }
    .bzImg {
      width: 120px;
      height: 148px;
      border-radius: 10px;
      object-fit: cover;
      flex: none;
      margin-right: 20px;
    }
    .bz-sb {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .bz-name {
        color: #323232;
        font-size: 18px;
        font-weight: 600;
        text-align: left;
        padding-bottom: 6px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      .bz-time {
        color: #323232;
        font-size: 14px;
        font-weight: 500;
        text-align: left;
        padding-bottom: 7px;
      }
      .bz-remark {
        color: #8a8a8a;
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        min-height: 60px;
        max-height: 65px;
      }
    }
    .bz-boter {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      .bx-flex {
        display: flex;
        align-items: center;
        width: 50%;
      }
      .fireIcon {
        width: 23px;
        height: 23px;
        margin-right: 6px;
        flex: none;
      }
      .viewIcon {
        width: 27px;
        height: 27px;
        margin-right: 6px;
        flex: none;
      }
      .bx-text {
        font-size: 16px;
        color: #666565;
      }
    }
  }
}
.newsMore {
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  color: #decc9e;
  font-size: 18px;
  cursor: pointer;
}
.newsIt {
  display: flex;
  justify-content: space-between;
  .newsItem {
    background: #fff;
    width: 290px;
    height: 330px;
    border-radius: 10px;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
    .newsImg {
      width: 270px;
      height: 190px;
      object-fit: cover;
      border-radius: 10px;
      flex: none;
      margin-bottom: 18px;
    }
    .newsTitle {
      font-size: 18px;
      color: #323232;
      font-weight: 500;
      text-align: left;
      margin-bottom: 9px;
      text-align: left;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
    .newsCont {
      font-size: 13px;
      color: #323232;
      font-weight: 400;
      text-align: left;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
  }
}
</style>
